import { render, staticRenderFns } from "./referrer.vue?vue&type=template&id=76cf1a82&"
import script from "./referrer.vue?vue&type=script&lang=js&"
export * from "./referrer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports